export default __webpack_public_path__ + "static/media/292.acf058ad.jpg";